import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "gfu-info-hero _mb-6" }
const _hoisted_2 = {
  key: 0,
  class: "gfu-info-hero-video gfu-info-hero-video--s",
  autoplay: "",
  loop: "",
  muted: ""
}
const _hoisted_3 = {
  key: 1,
  class: "gfu-info-hero-video gfu-info-hero-video--m",
  autoplay: "",
  loop: "",
  muted: ""
}
const _hoisted_4 = { class: "gfu-info-hero__content" }
const _hoisted_5 = { class: "gfu-hd gfu-hd--d2 gfu-hd--decorative _tc--accent-inverse" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "gfu-about-us" }
const _hoisted_8 = { class: "gfu-layout__main gfu-layout__main--narrow js-main-content" }
const _hoisted_9 = { class: "gfu-box gfu-box--huge" }
const _hoisted_10 = { class: "_mt-7 _mb-6" }
const _hoisted_11 = { class: "gfu-info-media _mb-6" }
const _hoisted_12 = { class: "gfu-info-media__body _tc--gray" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "gfu-info-media__aside" }
const _hoisted_15 = { class: "gfu-info-media gfu-info-media--reverse _mb-6" }
const _hoisted_16 = { class: "gfu-info-media__body _tc--gray" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "gfu-info-media__aside" }
const _hoisted_19 = { class: "gfu-info-media _mb-6" }
const _hoisted_20 = { class: "gfu-info-media__body _tc--gray" }
const _hoisted_21 = { class: "gfu-info-media__aside _mt-3" }
const _hoisted_22 = { class: "_mb-8" }
const _hoisted_23 = { class: "_tac" }
const _hoisted_24 = ["srcset"]
const _hoisted_25 = { class: "gfu-hd gfu-hd--h2 _mb-4" }
const _hoisted_26 = ["href"]
const _hoisted_27 = { class: "_mt-7 _mb-6" }
const _hoisted_28 = { class: "gfu-info-media _mb-6" }
const _hoisted_29 = { class: "gfu-info-media__body _tc--gray" }
const _hoisted_30 = { class: "gfu-info-media__aside" }
const _hoisted_31 = { class: "gfu-info-media gfu-info-media--reverse _mb-6" }
const _hoisted_32 = { class: "gfu-info-media__body _tc--gray" }
const _hoisted_33 = { class: "gfu-info-media__aside" }
const _hoisted_34 = { class: "_mt-7 _mb-6" }
const _hoisted_35 = { class: "gfu-by gfu-bt--b1" }
const _hoisted_36 = { class: "_mt-7 _mb-6" }
const _hoisted_37 = { class: "gfu-info-stats" }
const _hoisted_38 = { class: "_mb-3" }
const _hoisted_39 = { class: "_mb-6" }
const _hoisted_40 = { class: "_tac _mb-8" }
const _hoisted_41 = ["href"]
const _hoisted_42 = { class: "gfu-info-media _mb-3" }
const _hoisted_43 = { class: "gfu-info-media__body _tc--gray" }
const _hoisted_44 = ["innerHTML"]
const _hoisted_45 = { class: "gfu-info-media__aside" }
const _hoisted_46 = { class: "gfu-bt gfu-bt--caption _tc--light _flexcol _gap-1" }
const _hoisted_47 = {
  "format-key": "0",
  href: "https://www.adyen.com/",
  target: "_blank",
  rel: "nofollow noopener noreferrer",
  class: "gfu-link gfu-link--accent"
}
const _hoisted_48 = ["href"]
const _hoisted_49 = ["href"]
const _hoisted_50 = { class: "_mt-7 _mb-3" }
const _hoisted_51 = { class: "gfu-card-list gfu-card-list--wrap" }
const _hoisted_52 = { class: "gfu-card-list__item gfu-1of1 gfu-1of2--l _mt-3" }
const _hoisted_53 = { class: "gfu-info-contact" }
const _hoisted_54 = { class: "gfu-info-contact__icon" }
const _hoisted_55 = { class: "gfu-info-contact__content" }
const _hoisted_56 = ["innerHTML"]
const _hoisted_57 = { class: "_mt-2" }
const _hoisted_58 = ["href"]
const _hoisted_59 = { class: "gfu-card-list__item gfu-1of1 gfu-1of2--l _mt-3" }
const _hoisted_60 = { class: "gfu-info-contact" }
const _hoisted_61 = { class: "gfu-info-contact__icon" }
const _hoisted_62 = { class: "gfu-info-contact__content" }
const _hoisted_63 = ["innerHTML"]
const _hoisted_64 = { class: "_mt-2" }
const _hoisted_65 = ["href"]
const _hoisted_66 = { class: "gfu-card-list__item gfu-1of1 gfu-1of2--l _mt-3" }
const _hoisted_67 = { class: "gfu-info-contact" }
const _hoisted_68 = { class: "gfu-info-contact__icon" }
const _hoisted_69 = { class: "gfu-info-contact__content" }
const _hoisted_70 = ["innerHTML"]
const _hoisted_71 = { class: "_mt-2" }
const _hoisted_72 = ["href"]
const _hoisted_73 = { class: "gfu-card-list__item gfu-1of1 gfu-1of2--l _mt-3" }
const _hoisted_74 = { class: "gfu-info-contact" }
const _hoisted_75 = { class: "gfu-info-contact__icon" }
const _hoisted_76 = { class: "gfu-info-contact__content" }
const _hoisted_77 = ["innerHTML"]
const _hoisted_78 = { class: "_mt-2" }
const _hoisted_79 = ["href"]
const _hoisted_80 = { class: "gfu-card-list__item gfu-1of1 gfu-1of2--l _mt-3" }
const _hoisted_81 = { class: "gfu-info-contact" }
const _hoisted_82 = { class: "gfu-info-contact__icon" }
const _hoisted_83 = { class: "gfu-info-contact__content" }
const _hoisted_84 = ["innerHTML"]
const _hoisted_85 = { class: "_mt-2" }
const _hoisted_86 = ["href"]
const _hoisted_87 = { class: "gfu-card-list__item gfu-1of1 gfu-1of2--l _mt-3" }
const _hoisted_88 = { class: "gfu-info-contact" }
const _hoisted_89 = { class: "gfu-info-contact__icon" }
const _hoisted_90 = { class: "gfu-info-contact__content" }
const _hoisted_91 = ["innerHTML"]
const _hoisted_92 = { class: "_mt-2" }
const _hoisted_93 = ["href"]
const _hoisted_94 = { class: "gfu-bt _mt-2" }
const _hoisted_95 = ["href"]
const _hoisted_96 = { class: "gfu-bt _mt-2" }
const _hoisted_97 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_footer_navigation = _resolveComponent("footer-navigation")
  const _component_themed_image = _resolveComponent("themed-image")
  const _component_team_members_slider = _resolveComponent("team-members-slider")
  const _component_become_a_creator_stats = _resolveComponent("become-a-creator-stats")
  const _component_partners_slider = _resolveComponent("partners-slider")
  const _component_localize = _resolveComponent("localize")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_table_of_contents = _resolveComponent("table-of-contents")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_footer_navigation, {
      "current-page": _ctx.Resources.Layout.AboutUsLink
    }, null, 8 /* PROPS */, ["current-page"]),
    _createElementVNode("div", _hoisted_1, [
      ($options.isMobile)
        ? (_openBlock(), _createElementBlock("video", _hoisted_2, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("source", { src: "/content/movies/static/about-us/about-us-s.mp4" }, null, -1 /* CACHED */),
            _createElementVNode("source", { src: "/content/movies/static/about-us/about-us-s.webm" }, null, -1 /* CACHED */)
          ]))]))
        : (_openBlock(), _createElementBlock("video", _hoisted_3, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("source", { src: "/content/movies/static/about-us/about-us-l.mp4" }, null, -1 /* CACHED */),
            _createElementVNode("source", { src: "/content/movies/static/about-us/about-us-l.webm" }, null, -1 /* CACHED */)
          ]))])),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "gfu-info-hero__cover" }, null, -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.Resources.Common.MainTagline), 1 /* TEXT */),
        _createElementVNode("div", {
          class: "_mt-4",
          innerHTML: _ctx.Resources.AboutUs.VideoSectionParagraph
        }, null, 8 /* PROPS */, _hoisted_6)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("main", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("h2", {
              id: "history",
              ref: "history",
              class: "gfu-hd gfu-hd--h1"
            }, _toDisplayString(_ctx.Resources.AboutUs.HistorySectionHeader), 513 /* TEXT, NEED_PATCH */)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("h3", {
                id: "the-beginning",
                ref: "the-beginning",
                class: "gfu-hd gfu-hd--h3 _mb-3 gfu-heading--top-divider"
              }, _toDisplayString(_ctx.Resources.AboutUs.BeginningSectionHeader), 513 /* TEXT, NEED_PATCH */),
              _createElementVNode("span", {
                innerHTML: _ctx.Resources.AboutUs.BeginningSectionParagraph
              }, null, 8 /* PROPS */, _hoisted_13)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_themed_image, {
                src: "/content/images/static/about-us/handles.svg",
                alt: "The beginning"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("h3", {
                id: "the-evolution",
                ref: "the-evolution",
                class: "gfu-hd gfu-hd--h3 _mb-3 gfu-heading--top-divider"
              }, _toDisplayString(_ctx.Resources.AboutUs.EvolutionSectionHeader), 513 /* TEXT, NEED_PATCH */),
              _createElementVNode("span", {
                innerHTML: _ctx.Resources.AboutUs.EvolutionSectionParagraph
              }, null, 8 /* PROPS */, _hoisted_17)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_themed_image, {
                src: "/content/images/static/about-us/evolution.svg",
                alt: "The evolution"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("h3", {
                id: "today",
                ref: "today",
                class: "gfu-hd gfu-hd--h3 _mb-3 gfu-heading--top-divider"
              }, _toDisplayString(_ctx.Resources.AboutUs.TodaySectionHeader), 513 /* TEXT, NEED_PATCH */),
              _createTextVNode(" " + _toDisplayString(_ctx.Resources.AboutUs.TodaySectionParagraph), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_themed_image, {
                src: "/content/images/static/about-us/stairs.svg",
                alt: "Today"
              })
            ])
          ]),
          _createElementVNode("h2", {
            id: "team",
            ref: "team",
            class: "gfu-hd gfu-hd--h1 _mt-7 _mb-6"
          }, _toDisplayString(_ctx.Resources.AboutUs.TeamSectionHeader), 513 /* TEXT, NEED_PATCH */),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_team_members_slider, { members: _ctx.teamMembers }, null, 8 /* PROPS */, ["members"])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("picture", null, [
              _createElementVNode("source", {
                srcset: $options.teamMembersUrl,
                media: "(min-width: 992px)"
              }, null, 8 /* PROPS */, _hoisted_24),
              _createVNode(_component_themed_image, {
                class: "gfu-1of1 _mb-4",
                src: "/content/images/static/about-us/team-faces-s.svg?v=1",
                alt: $options.themeImageAlt
              }, null, 8 /* PROPS */, ["alt"])
            ]),
            _createElementVNode("h4", _hoisted_25, _toDisplayString(_ctx.Resources.AboutUs.TeamSectionAdditionalParagraph), 1 /* TEXT */),
            _createElementVNode("a", {
              href: $options.joinUsMailUrl,
              class: "gfu-btn gfu-btn--soft gfu-btn--primary gfu-btn--wide"
            }, _toDisplayString(_ctx.Resources.AboutUs.TeamSectionButtonText), 9 /* TEXT, PROPS */, _hoisted_26)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("h2", {
              id: "safety-and-security",
              ref: "safety-and-security",
              class: "gfu-hd gfu-hd--d1"
            }, _toDisplayString(_ctx.Resources.AboutUs.SafetyAndSecuritySectionHeader), 513 /* TEXT, NEED_PATCH */)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("h3", {
                id: "human-touch",
                ref: "human-touch",
                class: "gfu-hd gfu-hd--h3 _mb-3 gfu-heading--top-divider"
              }, _toDisplayString(_ctx.Resources.AboutUs.HumanTouchSectionHeader), 513 /* TEXT, NEED_PATCH */),
              _createTextVNode(" " + _toDisplayString(_ctx.Resources.AboutUs.HumanTouchSectionParagraph), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_themed_image, {
                src: "/content/images/static/about-us/robot.svg",
                alt: "Human touch"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("h3", {
                id: "reliability",
                ref: "reliability",
                class: "gfu-hd gfu-hd--h3 _mb-3 gfu-heading--top-divider"
              }, _toDisplayString(_ctx.Resources.AboutUs.ReliabilitySectionHeader), 513 /* TEXT, NEED_PATCH */),
              _createTextVNode(" " + _toDisplayString(_ctx.Resources.AboutUs.ReliabilitySectionParagraph), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createVNode(_component_themed_image, {
                src: "/content/images/static/about-us/reliability.svg",
                alt: "Reliability"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("h2", {
              id: "community",
              ref: "community",
              class: "gfu-hd gfu-hd--h1"
            }, _toDisplayString(_ctx.Resources.AboutUs.CommunitySectionHeader), 513 /* TEXT, NEED_PATCH */)
          ]),
          _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.Resources.AboutUs.CommunitySectionParagraph), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("h2", {
              id: "in-numbers",
              ref: "in-numbers",
              class: "gfu-hd gfu-hd--h1"
            }, _toDisplayString(_ctx.Resources.AboutUs.PlatformInNumbersSectionHeader), 513 /* TEXT, NEED_PATCH */)
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createVNode(_component_become_a_creator_stats, _normalizeProps(_guardReactiveProps($setup.creatorStatistics)), null, 16 /* FULL_PROPS */)
          ]),
          _createElementVNode("h2", {
            id: "partners",
            ref: "partners",
            class: "gfu-hd gfu-hd--h1 _mt-7 _mb-3"
          }, _toDisplayString(_ctx.Resources.AboutUs.PartnersSectionHeader), 513 /* TEXT, NEED_PATCH */),
          _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.Resources.AboutUs.PartnersSectionSubheader), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_partners_slider, { partners: _ctx.partners }, null, 8 /* PROPS */, ["partners"])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("a", {
              href: $props.links.becomeACreatorUrl,
              class: "gfu-btn gfu-btn--soft gfu-btn--primary gfu-btn--wide"
            }, _toDisplayString(_ctx.Resources.AboutUs.PartnersSectionButtonText), 9 /* TEXT, PROPS */, _hoisted_41)
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("h2", {
                id: "legal",
                ref: "legal",
                class: "gfu-hd gfu-hd--h1 _mb-3"
              }, _toDisplayString(_ctx.Resources.AboutUs.LegalSectionHeader), 513 /* TEXT, NEED_PATCH */),
              _createElementVNode("p", {
                innerHTML: _ctx.Resources.AboutUs.LegalSectionParagraph
              }, null, 8 /* PROPS */, _hoisted_44)
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createVNode(_component_themed_image, {
                src: "/content/images/static/about-us/map-of-europe.svg",
                alt: "Legal"
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createVNode(_component_localize, {
              resource: _ctx.Resources.AboutUs.LegalSectionCaption
            }, {
              default: _withCtx(() => [
                _createElementVNode("a", _hoisted_47, _toDisplayString(_ctx.Resources.AboutUs.LegalSectionLink), 1 /* TEXT */),
                _cache[3] || (_cache[3] = _createTextVNode(". ", -1 /* CACHED */))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["resource"]),
            _createVNode(_component_localize, {
              resource: _ctx.Resources.AboutUs.LegalSectionDocsParagraph
            }, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  "format-key": "0",
                  href: $options.termsOfServiceUrl,
                  target: "_blank",
                  rel: "nofollow noopener noreferrer",
                  class: "gfu-link gfu-link--accent"
                }, _toDisplayString(_ctx.Resources.AboutUs.LegalSectionTermsOfServiceLink), 9 /* TEXT, PROPS */, _hoisted_48),
                _createElementVNode("a", {
                  "format-key": "1",
                  href: $options.privacyPolicyUrl,
                  target: "_blank",
                  rel: "nofollow noopener noreferrer",
                  class: "gfu-link gfu-link--accent"
                }, _toDisplayString(_ctx.Resources.AboutUs.LegalSectionPrivacyPolicyLink), 9 /* TEXT, PROPS */, _hoisted_49)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["resource"])
          ]),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("h2", {
              id: "reach-out",
              ref: "reach-out",
              class: "gfu-hd gfu-hd--h1"
            }, _toDisplayString(_ctx.Resources.AboutUs.ReachOutSectionHeader), 513 /* TEXT, NEED_PATCH */)
          ]),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _createVNode(_component_base_icon, { name: "user" })
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("p", {
                    innerHTML: _ctx.Resources.AboutUs.ContactForBackerParagraph
                  }, null, 8 /* PROPS */, _hoisted_56)
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("a", {
                    href: $props.links.contactForBackersUrl,
                    class: "gfu-link gfu-link--accent"
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.Resources.AboutUs.ContactForBackerLink) + " ", 1 /* TEXT */),
                    _createVNode(_component_base_icon, { name: "angle-right" })
                  ], 8 /* PROPS */, _hoisted_58)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _createVNode(_component_base_icon, { name: "user-edit" })
                ]),
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("p", {
                    innerHTML: _ctx.Resources.AboutUs.ContactForCreatorParagraph
                  }, null, 8 /* PROPS */, _hoisted_63)
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("a", {
                    href: $props.links.contactForCreatorsUrl,
                    class: "gfu-link gfu-link--accent"
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.Resources.AboutUs.ContactForCreatorLink) + " ", 1 /* TEXT */),
                    _createVNode(_component_base_icon, { name: "angle-right" })
                  ], 8 /* PROPS */, _hoisted_65)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("div", _hoisted_68, [
                  _createVNode(_component_base_icon, { name: "users-crown" })
                ]),
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("p", {
                    innerHTML: _ctx.Resources.AboutUs.ContactForMediaParagraph
                  }, null, 8 /* PROPS */, _hoisted_70)
                ]),
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("a", {
                    href: $props.links.contactForMediaUrl,
                    class: "gfu-link gfu-link--accent"
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.Resources.AboutUs.ContactForMediaLink) + " ", 1 /* TEXT */),
                    _createVNode(_component_base_icon, { name: "angle-right" })
                  ], 8 /* PROPS */, _hoisted_72)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("div", _hoisted_74, [
                _createElementVNode("div", _hoisted_75, [
                  _createVNode(_component_base_icon, { name: "user-tie" })
                ]),
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("p", {
                    innerHTML: _ctx.Resources.AboutUs.ContactForBusinessParagraph
                  }, null, 8 /* PROPS */, _hoisted_77)
                ]),
                _createElementVNode("div", _hoisted_78, [
                  _createElementVNode("a", {
                    href: $props.links.businessContactUrl,
                    class: "gfu-link gfu-link--accent"
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.Resources.AboutUs.ContactForBusinessLink) + " ", 1 /* TEXT */),
                    _createVNode(_component_base_icon, { name: "angle-right" })
                  ], 8 /* PROPS */, _hoisted_79)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_80, [
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("div", _hoisted_82, [
                  _createVNode(_component_base_icon, { name: "user-hard-hat" })
                ]),
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("p", {
                    innerHTML: _ctx.Resources.AboutUs.ContactForRecruitmentParagraph
                  }, null, 8 /* PROPS */, _hoisted_84)
                ]),
                _createElementVNode("div", _hoisted_85, [
                  _createElementVNode("a", {
                    href: $options.joinUsMailUrl,
                    class: "gfu-link gfu-link--accent"
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.Resources.AboutUs.ContactForRecruitmentLink) + " ", 1 /* TEXT */),
                    _createVNode(_component_base_icon, { name: "angle-right" })
                  ], 8 /* PROPS */, _hoisted_86)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_87, [
              _createElementVNode("div", _hoisted_88, [
                _createElementVNode("div", _hoisted_89, [
                  _createVNode(_component_base_icon, { name: "user-headset" })
                ]),
                _createElementVNode("div", _hoisted_90, [
                  _createElementVNode("p", {
                    innerHTML: _ctx.Resources.AboutUs.ContactForMarketingParagraph
                  }, null, 8 /* PROPS */, _hoisted_91)
                ]),
                _createElementVNode("div", _hoisted_92, [
                  _createElementVNode("a", {
                    href: $props.links.promotionContactUrl,
                    class: "gfu-link gfu-link--accent"
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.Resources.AboutUs.ContactForMarketingLink) + " ", 1 /* TEXT */),
                    _createVNode(_component_base_icon, { name: "angle-right" })
                  ], 8 /* PROPS */, _hoisted_93)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_94, [
            _createVNode(_component_localize, {
              resource: _ctx.Resources.AboutUs.ContactInformationParagraph
            }, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  "format-key": "0",
                  href: $options.officialPhoneNumberUrl
                }, _toDisplayString($options.officialPhoneNumber), 9 /* TEXT, PROPS */, _hoisted_95)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["resource"])
          ]),
          _createElementVNode("div", _hoisted_96, [
            _createVNode(_component_localize, {
              resource: _ctx.Resources.AboutUs.GeneralProductSafetyRegulationContactParagraph
            }, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  "format-key": "0",
                  href: $options.authoritiesMailUrl
                }, _toDisplayString($options.authoritiesMail), 9 /* TEXT, PROPS */, _hoisted_97)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["resource"])
          ])
        ])
      ]),
      _createVNode(_component_table_of_contents)
    ])
  ]))
}